import ServiceFactory from '../../../services/factory'

const service = ServiceFactory.get('person')
export default {

  LIST({commit, dispatch}, {options, extra}) {
    commit('app/START_LOADING', null, {root: true})
    return service.paginate(options, extra).then((response) => {
      commit('SAVE_LIST', response.data)
      return response.data
    }).catch((error) => {
      return dispatch('app/HANDLE_API_ERROR', error, {root: true})
    }).finally(() => {
      commit('app/STOP_LOADING', null, {root: true})
    })
  },
  DELETE({commit, dispatch}, person) {
    commit('app/START_LOADING', null, {root: true})
    return service.delete(person.id)
      .then((response) => {
        commit('DELETE', person)
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },

  DELETE_FINGERPRINT({commit, dispatch}, fingerprint) {
    commit('app/START_LOADING', null, {root: true})
    return service.delete_fingerprint(fingerprint.person.id, fingerprint.finger.position)
      .then((response) => {
        return response.data
      }).catch((error) => {
        commit('app/STOP_LOADING', null, {root: true})
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },

  GET({commit, dispatch}, {id}) {
    commit('app/START_LOADING', null, {root: true})
    return service.get(id)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  GET_ACCESS({commit, dispatch}, {id, unity_id}) {
    commit('app/START_LOADING', null, {root: true})
    return service.get_access(id, unity_id)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  GET_FINGERPRINTS({commit, dispatch}, {id}) {
    commit('app/START_LOADING', null, {root: true})
    return service.get_fingerprints(id)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  POST({commit, dispatch}, {model}) {
    return service.post(model)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  PATCH({commit, dispatch}, {id, model}) {
    return service.patch(id, model)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  GET_FINGERS({commit, dispatch}) {
    commit('app/START_LOADING', null, {root: true})
    return service.get_fingers()
      .then((response) => {
        commit('SAVE_FINGERS', response.data)
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },

  CAPTURE({commit, dispatch}, {id, position, payload}) {
    commit('app/START_LOADING', null, {root: true})
    return service.capture(id, position, payload)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },
  GET_ACCESS_LOG({commit, dispatch}, {id, unity_id, options}) {
    commit('app/START_LOADING', null, {root: true})
    return service.get_access_log(id, unity_id, options)
      .then((response) => {
        return response.data
      }).catch((error) => {
        return dispatch('app/HANDLE_API_ERROR', error, {root: true})
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },

}
